import { createSelector } from 'reselect';
import { ModelRuleSearchView } from './view/ModelRuleSearchView';
import {
  getArmiesLoading,
  getVersionsLoading,
} from '@Selectors/builder/myArmyList/common/selector';
import { ArmyView } from '@Selectors/builder/myBuilder/builder/new/view/ArmyView';
import { getArmies } from '@Selectors/builder/myBuilder/selector';
import { VersionGamePresenter } from '@Selectors/common/VersionGamePresenter';

export const ModelRuleSearchPresenter = createSelector(
  [VersionGamePresenter, getArmies, getVersionsLoading, getArmiesLoading],
  (
    versions,
    armies,
    versionsIsLoading,
    armiesIsLoading,
  ): ModelRuleSearchView => {
    return new ModelRuleSearchView({
      versions: versions,
      armies: armies.map(
        (item) =>
          new ArmyView({
            id: item.id,
            name: item.name,
            versionId: item.versionId,
          }),
      ),
      isLoading: versionsIsLoading || armiesIsLoading,
      canSubmit: !(versionsIsLoading || armiesIsLoading),
    });
  },
);
